module.exports = __webpack_public_path__ + "static/our-goal-c28d6b6ae88f03c397113c237dab4f7e.png";